/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A tag as the superadmin sees it: with the number of tutorials it is assigned to.
 * @export
 * @interface TutorialTagWithUsage
 */
export interface TutorialTagWithUsage {
    /**
     * 
     * @type {string}
     * @memberof TutorialTagWithUsage
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TutorialTagWithUsage
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TutorialTagWithUsage
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof TutorialTagWithUsage
     */
    created_at: Date;
    /**
     * Number of tutorials the tag is assigned to
     * @type {number}
     * @memberof TutorialTagWithUsage
     */
    usage_count?: number;
}

/**
 * Check if a given object implements the TutorialTagWithUsage interface.
 */
export function instanceOfTutorialTagWithUsage(value: object): value is TutorialTagWithUsage {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function TutorialTagWithUsageFromJSON(json: any): TutorialTagWithUsage {
    return TutorialTagWithUsageFromJSONTyped(json, false);
}

export function TutorialTagWithUsageFromJSONTyped(json: any, ignoreDiscriminator: boolean): TutorialTagWithUsage {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'id': json['id'],
        'created_at': (new Date(json['created_at'])),
        'usage_count': json['usage_count'] == null ? undefined : json['usage_count'],
    };
}

export function TutorialTagWithUsageToJSON(json: any): TutorialTagWithUsage {
    return TutorialTagWithUsageToJSONTyped(json, false);
}

export function TutorialTagWithUsageToJSONTyped(value?: TutorialTagWithUsage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'id': value['id'],
        'created_at': ((value['created_at']).toISOString()),
        'usage_count': value['usage_count'],
    };
}

